var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowEnter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.645,
    height: 26.734,
    viewBox: "0 0 35.645 26.734",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow-enter",
    d: "M33.723,21.823,26.3,28.809a1.114,1.114,0,1,0,1.527,1.622l9.468-8.911a1.114,1.114,0,0,0,0-1.622l-9.468-8.911A1.114,1.114,0,0,0,26.3,12.609l7.423,6.986H8.684a4.456,4.456,0,0,1-4.456-4.456V5.114A1.114,1.114,0,1,0,2,5.114V15.139a6.683,6.683,0,0,0,6.684,6.684Z",
    transform: "translate(-2 -4)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowEnter);
export default __webpack_public_path__ + "static/media/arrow-enter.cd0eacc47321de2a9fc6aaca5ad4dbb9.svg";
export { ForwardRef as ReactComponent };